/**
 * useSchemesListScreen.js
 * -----------------------
 * Hook for Schemes list screen using shared useMasterList.
 */
import { useMasterList } from '../../common/useMasterList';
import * as schemesApi from '../api/schemesApi';

export function useSchemesListScreen() {
  return useMasterList({
    entityName: 'Scheme',
    apiClient: schemesApi.schemesClient,
    fetchList: schemesApi.listSchemes,
    archiveItem: schemesApi.archiveScheme,
    deleteItem: schemesApi.deleteScheme,
  });
}
